import template from './ps-record-filter.html';
// import RecordFilter from './RecordFilter';

/**
 * KO component for filtering api/record data
 *
 * @kind component
 * @class RecordFilterViewModel
 *
 * @param {Object} params - The parameters object for the component.
 * @param {HTMLElement} rootElement - The root element that the component is bound to
 * @param {string} [params.show_filter] - Controls if the component is visible. Can be an observable
//  * @param {string} [params.permanent_filters] - Sets filters that must always be present. Will be unwrapped
 * @param {function} [params.onFiltersUpdated] - An event handler to fire when the filters are updated
 * @param {string} [params.fields] - Sets the fields that are available. Will be unwrapped
 */
class RecordFilterViewModel
{
	constructor(params, rootElement)
	{
		this.params = params;

		const RecordFilter = Grape.dataModel.get('RecordFilter');
		this.filter = new RecordFilter();

		this.saved_filter = ko.observable();
		this.fields = ko_helper.safe_observable(params.fields, []);
		this.show_filter = ko_helper.safe_observable(params.show_filter, true);
		this.onFiltersUpdated = params.onFiltersUpdated ?? null;

		this.active_filter = ko.pureComputed(() => {
			if (this.saved_filter())
				return new RecordFilter(this.saved_filter());
			else
				return this.filter;
		});

		this.active_string = ko.pureComputed(() => {
			let active_filter = this.active_filter();
			return active_filter?.filter?.filterString();
		});
	}

	apply()
	{
		let active = this.active_filter();

		// let filters = [];
		// if (active.filter.filter().length > 0)
		// 	filters.push(active.filter);

		// if (active.permanent_filters.filter().length > 0)
		// 	filters.push(active.permanent_filters);

		let effective = active.filter.get();
		effective.filter_join = effective.join;
		delete effective.join;

		if (this.onFiltersUpdated instanceof Function)
			this.onFiltersUpdated(effective);
	}

	async save()
	{
		let res = await this.filter.save();
		if (res.status == 'OK')
		{
			Grape.cache.invalidate('RecordFilters');
			this.saved_filter(this.filter);
		}
		else
			Grape.alerts.alert({ type: 'error', title: 'Save Failure', message: res.message });
	}
}

export default {
	name: 'ps-record-filter',
	viewModel: RecordFilterViewModel,
	module_type: 'ko',
	template: template
};
